<script>
import actionListMenuItemCommandMixin from '@/common/mixins/actionListMenuItemCommandMixin'
import { ApiClient } from '@/helpers/api-client/ApiClient'
import ApplicantInfoBlock from '@/common/components/application/ApplicantInfoBlock'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import { ApplicationStatuses } from '@/enums/ApplicationStatuses'
import ApplicationStatusInfoBlock from '@/common/components/application/ApplicationStatusInfoBlock'
import ApproveApplicationFormBlock from '@/common/components/application/form-blocks/ApproveApplicationFormBlock'
import approveFormContextMixin from '@/common/mixins/approveFormContextMixin'
import approveApplicationMixin from '@/mixins/approveApplicationMixin'
import { cloneObject } from '@/common/helpers'
import { ClosedSigner } from '@/common/helpers/signer/close-certificates'
import EagerPreviewVisitorDocumentListHydrator from '@/common/hydrators/EagerPreviewVisitorDocumentListHydrator'
import FormSection from '@/common/components/application/FormSection.vue'
import StepFiveIcon from '@/common/components/application/step-icons/StepFiveIcon.vue'
import ImportFileFormBlock from '@/common/components/application/form-blocks/visitors/ImportFileFormBlock.vue'
import ImportTransportFileFormBlock from '@/common/components/application/form-blocks/transports/ImportTransportFileFormBlock.vue'
import InternalCommentBlock from '@/common/components/application/internalCommentBlock.vue'
import loadCadesplugin from '@/common/helpers/signer/cadesplugin_api'
import { Logger } from '@/common/helpers/Logger'
import mainMixin from '@/common/mixins/mainMixin'
import OfferModal from '@/common/components/application/OfferModal.vue'
import OrganizationFormBlock from '@/common/components/application/form-blocks/organization/OrganizationFormBlock.vue'
import { OrganizationSubjects } from '@/enums/OrganizationSubjects'
import PassAccessDto from '@/common/classes/dto/PassAccessDto'
import PassErrorsBlock from '@/common/components/application/form-blocks/PassErrorsBlock'
import PassFormBlock from '@/common/components/application/form-blocks/pass/PassFormBlock.vue'
import PermissionsEnum from '@/common/enums/PermissionsEnum'
import PermissionsMixin from '@/common/mixins/PermissionsMixin'
import { ResponseStatuses } from '@/enums/ResponseStatuses'
import ScanCopyFormBlock from '@/components/application/ScanCopyFormBlock'
import SignModal from '@/common/components/application/form-blocks/SignModal.vue'
import StepFourIcon from '@/common/components/application/step-icons/StepFourIcon.vue'
import StepThreeIcon from '@/common/components/application/step-icons/StepThreeIcon.vue'
import StepTwoIcon from '@/common/components/application/step-icons/StepTwoIcon.vue'
import { TerminalRegionActions } from '@/common/enums/TerminalRegionActions'
import TimeTypeDto from '@/common/classes/dto/TimeTypeDto'
import { TimeTypes } from '@/enums/TimeTypes'
import Transport from '@/common/classes/Transport'
import { TransportTypes } from '@/enums/TransportTypes'
import { UserRoles } from '@/enums/UserRoles'
import { VesselAccesses as VesselAccessesEnum } from '@/common/enums/VesselAccesses'
import VisitorDocumentListKeyItemPairHydrator from '@/common/hydrators/VisitorDocumentListKeyItemPairHydrator'
import Visitor from '@/common/classes/Visitor'
import VisitorsFormBlock from '@/components/application/form-blocks/visitors/VisitorsFormBlock.vue'
import ConfiguredApplicationDto from '@/common/classes/dto/ConfiguredApplicationDto'
import OrganizationDto from '@/common/classes/dto/OrganizationDto'
import CheckOrganizationInn from '@/common/eventListners/CheckOrganizationInn'
import CheckNeedAttorney from '@/common/eventListners/CheckNeedAttorney'
import NationalityIdChanged from '@/common/eventListners/NationalityIdChanged'
import SubjectIdChanged from '@/common/eventListners/SubjectIdChanged'
import { PassKinds } from '@/common/enums/PassKinds'
import { PassSectionFieldAliases } from '@/common/enums/PassSectionFieldAliases'
import TangiblesFormBlock from '@/common/components/application/form-blocks/tangibles/TangiblesFormBlock.vue'
import debounce from 'lodash.debounce';

let setOrganizationListeners = new Map();

export default {
  name: 'Home',

  components: {
    ApplicantInfoBlock,
    ApplicationStatusInfoBlock,
    ApproveApplicationFormBlock,
    FormSection,
    ImportFileFormBlock,
    ImportTransportFileFormBlock,
    OfferModal,
    OrganizationFormBlock,
    PassErrorsBlock,
    PassFormBlock,
    ScanCopyFormBlock,
    SignModal,
    StepFiveIcon,
    StepFourIcon,
    StepThreeIcon,
    StepTwoIcon,
    VisitorsFormBlock,
    InternalCommentBlock,
    TangiblesFormBlock
  },

  mixins: [
    mainMixin,
    applicationFormMixin,
    approveApplicationMixin,
    approveFormContextMixin,
    PermissionsMixin,
    actionListMenuItemCommandMixin
  ],

  data: () => {
    const defaultForm = {
      organization: {
        subject_id: OrganizationSubjects.Entity,
        name: null,
        short_name: null,
        inn: null,
        position_of_manager: null,
        director_name: null,
        phone: '',
        innControlSumErr: false,
        innError: false,
        nationality_id: 182,
        address: null,
        // fiz_address: null,
        email: null,
        website: null
      },
      application: {
        additional_purpose: null,
        agent_organization_id: null,
        application_group_purpose_id: null,
        documents: {},
        berth: null,
        flag: null,
        need_additional_purpose: 0,
        need_type: 0,
        need_agent_check: 0,
        pass_access: 1,
        pass_kind: null,
        period_count: 1,
        period_of: null,
        period_to: null,
        subdivision_id: null,
        terminal_region_id: null,
        time_of: '00:00',
        time_to: '23:59',
        time_type: 'one',
        vessel: null,
        vessel_access_id: VesselAccessesEnum.WITHOUT_VESSEL,
        terminal_organization_inn: null,
        require_user_sign: null,
        custom_fields: {},
        internal_comment: '',
        contract_number: null,
        contract_date: null,
        payment_type_id: null,
        contract_end_date: null,
        contract_unlimited: false,
        contract_org_name: '',
        contract_org_inn: '',
        terminal_sectors: [],
        has_radioactive_cargo: 0,
        terminal_id: null
      },
      visitors: [new Visitor()],
      scanCopiesUrls: [],
      vessels: []
    }

    const defaultApproveForm = {
      visitors: [],
      sending: false
    }

    const configuredApplication = new ConfiguredApplicationDto({})

    return {
      defaultForm,
      defaultApproveForm,

      form: cloneObject(defaultForm),
      approveForm: cloneObject(defaultApproveForm),
      personalNationalities: [
        {
          id: 186,
          full_name: 'Россия',
          iso2: 'RU'
        }
      ],

      typeaheads: {
        personals: [],
        transports: [],
        unit: [],
        car: []
      },

      applicantInfoRoles: [
        UserRoles.SB,
        UserRoles.SB_TRUCK,
        UserRoles.SB_OTHER,
        UserRoles.SUBDIVISION,
        UserRoles.MANAGEMENT_BUILDING
      ],

      configuredApplication,

      activityOrganizations: [],
      agentOrganizations: [],
      applicationPdfMenuHTML: '',
      applicationPurposes: [],
      applicationStatus: {},
      applicationStatuses: [],
      applicationDocuments: [],
      applicationCustomFields: [],
      cfgOrganizationSubjectTimeType: [],
      cfgFormFields: [],
      disabledSubmitButton: false,
      documentMasks: [],
      errors: {},
      errorType: false,
      excelExample: null,
      formSending: false,
      hasUploadedScanCopy: false,
      innControlSumErr: false,
      markModelError: false,
      nationalityDocuments: [],
      needLoadPage: true,
      organizationDisabled: true,
      organizationSubjects: [],
      organizationSubjectsResidency: [],
      passKinds: [],
      passAccesses: [],
      personalIdentifications: [],
      purposeSubdivisions: [],
      restoredData: false,
      signers: {},
      statusActions: {},
      statusKey: 0,
      subjectPurpose: [],
      tangibles: [],
      terminalRegions: [],
      terminalRegionSectors: [],
      terminalSubdivisions: [],
      terminalTariffPeriods: [],
      terminal: {},
      terminalOrganizations: [],
      textOffer: null,
      transportColors: [],
      transportMarks: [],
      transportModels: [],
      transportTypes: [],
      transportStsTypes: [],
      transportDocuments: [],
      vesselBerthBook: [],
      vesselAccesses: [],
      paymentTypes: [],
      visitorCategories: [],
      visitorCategoryPurposes: [],
      visitorsFormBlockKey: 0,
      agreement: false,
      agreementErrorMessage: false
    }
  },

  computed: {
    canAttachScanCopy() {
      return Number(this.configuration.can_attach_scancopy) === 1
    },

    timezone() {
      return String(this.configuration.default_timezone ?? 'Europe/Moscow')
    },

    permissionsEnum() {
      return PermissionsEnum
    },

    actions() {
      let actions = []
      for (const actionName in this.statusActions) {
        const action = this.statusActions[actionName]
        if (this.showActionButton(action)) {
          actions.push(action)
        }
      }

      return actions
    },

    showImportFileFormBlock() {
      return this.form.application?.pass_kind !== PassKinds.TRANSPORT && this.canImportVisitorsFromExcel
    },

    getVisitorsSectionTitle() {
      if (this.isPassKindTransport) {
        return 'Транспортные средства'
      }
      if (this.isPassKindPedestrian) {
        return 'Посетители'
      }
      if (this.isPassKindMaterial) {
        return 'Предъявители'
      }
      return 'Посетители'
    },

    applicationGroupPurpose() {
      return this.applicationPurposes[this.form.application.application_group_purpose_id]
    },

    applicationRegion() {
      return this.applicationGroupPurpose?.regions.find((region) => {
        return region.terminal_region_id === this.form.application.terminal_region_id
      })
    },

    approveAction() {
      return this.actions.find((action) => Boolean(action.for_approval) === true)
    },

    baseBackendUrl() {
      return process.env.VUE_APP_API_BASE_URL
    },

    baseUrl() {
      return process.env.BASE_URL
    },

    calculatedApplicationDocuments() {
      const form = this.form
      const application = form.application
      const organization = form.organization
      const requiresMchd = this.configuredApplication.requireUserSign && organization.need_attorney

      const documents = []
      for (const document of this.applicationDocuments) {
        if (![application.time_type, TimeTypes.ALL].includes(document.pass_type)) {
          continue
        }
        if (![application.application_group_purpose_id, null].includes(document.purpose_id)) {
          continue
        }
        if (![application.terminal_region_id, null].includes(document.region_id)) {
          continue
        }
        if (![organization.subject_id, null].includes(document.subject_id)) {
          continue
        }
        if (!requiresMchd && document.is_mchd) {
          continue
        }
        documents.push(document)
      }

      documents.sort((a, b) => a.document.sort - b.document.sort)

      return documents
    },

    calculatedTerminalRegions() {
      const purposeId = this.form.application.application_group_purpose_id
      const applicationPurpose = this.applicationPurposes[purposeId]

      if (applicationPurpose === undefined) {
        return []
      }

      const purposeRegions = applicationPurpose.regions
      if (this.isView) {
        return this.terminalRegions
      }

      return this.terminalRegions.filter((region) => {
        if (
          !['all', this.form.application.time_type].includes(region.pass_type)
        ) {
          return false
        }

        return purposeRegions.findIndex(purposeRegion => purposeRegion.terminal_region_id === parseInt(region.id)) > -1
      })
    },

    canScud() {
      return Boolean(
        this.configuration.can_scud &&
        [UserRoles.SB, UserRoles.SB_OTHER, UserRoles.SB_TRUCK].includes(this.user?.role) &&
        this.form.application.status === ApplicationStatuses.KTSP
      )
    },

    canSign() {
      return this.user && [
        UserRoles.PNT,
        UserRoles.SB,
        UserRoles.SB_OTHER,
        UserRoles.SB_TRUCK,
        UserRoles.SUBDIVISION
      ].includes(this.user.role)
    },

    canViewThisButtons() {
      return Boolean(
        (this.canPrint(this.form.application) && this.applicationPdfMenuHTML !== ' ') ||
        (
          Number(this.configuration.can_attach_scancopy) === 1 &&
          Number(this.form.application.user_id) === Number(this.user.id) &&
          this.form.application.status === 'awaiting_signing'
        ) ||
        this.canDuplicate(this.form.application) ||
        this.canDelete(this.form.application)
      )
    },

    certListBoxId() {
      return `certListBox-${this.form.application.id}`
    },

    equalSubdivisions() {
      let applicationSubdivisionId = this.form.application.subdivision_id
      if (![null, undefined].includes(applicationSubdivisionId)) {
        applicationSubdivisionId = parseInt(applicationSubdivisionId)
      }

      return Boolean(this.user.subdivisions.find(subdivisionId => parseInt(subdivisionId) === applicationSubdivisionId))
    },

    formBlockPurposes() {
      if (this.isView) {
        return this.applicationPurposes
      }

      const showVisitorsCategory = Boolean(
        this.cfgFormFields[PassSectionFieldAliases.VISITORS_CATEGORY].pass_kind_visible.includes(
          this.form.application.pass_kind
        )
      )

      if (showVisitorsCategory && !this.form.application.visitors_category) {
        return []
      }

      let purposes = cloneObject(this.applicationPurposes)
      let subjectPurposes = showVisitorsCategory
        ? this.visitorCategoryPurposes[this.form.application.visitors_category]
        : this.subjectPurpose[this.form.organization.subject_id]

      for (const id in purposes) {
        if (!subjectPurposes.includes(Number(id))) {
          delete purposes[id]
        }
      }

      return purposes
    },

    isDisabledSubmitButton() {
      return (
        this.formSending ||
        this.form.organization.innError ||
        this.disabledSubmitButton ||
        this.errorType ||
        this.markModelError ||
        this.innControlSumErr
      )
    },

    isManagementBuildingTerminalRegion() {
      const purposeId = this.form.application.terminal_region_id
      const purposes = Object.values(this.terminalRegions)
      const result = purposes ? purposes.find(purpose => {
        return Number(purpose.id) === Number(purposeId)
      }) : null

      return result && result.alias === 'management_building'
    },

    isOnegaTerminalRegion() {
      const purposeId = this.form.application.terminal_region_id
      const purposes = Object.values(this.terminalRegions)
      const result = purposes ? purposes.find(purpose => {
        return Number(purpose.id) === Number(purposeId)
      }) : null

      return result && result.alias === 'onega'
    },

    isScanCopy() {
      return this.isView && this.form.application.status === 'awaiting_signing'
    },

    isSigning() {
      if (this.user.isTerminalStaff && this.terminal.inn === this.form.organization.inn) {
        return false
      }

      return !(this.isView && this.form.application.status === 'awaiting_signing') &&
        (
          (
            this.applicationRegion && this.applicationRegion.esignature &&
            (this.applicationRegion.esignature === this.form.application.time_type || this.applicationRegion.esignature === 'all')
          ) ||
          (!this.applicationGroupPurpose && this.form.application.time_type !== TimeTypes.ONE)
        )
    },

    pageTitle() {
      const pageTitle = 'Сервис по оформлению заявок на пропуск'

      if (!this.isDuplicate && this.form && this.form.application && this.form.application.number) {
        return `№${this.form.application.number} - ${pageTitle}`
      }

      return pageTitle
    },

    showScanCopyBlock() {
      if (this.applicationRegion?.esignature) {
        if (this.user.role === UserRoles.USER) {
          return (this.form.application.has_user_sign === 0 && this.form.application.status === ApplicationStatuses.AWAITING_SIGNING) ||
            this.form.scanCopiesUrls.length > 0
        } else {
          return this.form.scanCopiesUrls.length > 0
        }
      }

      return false
    },

    showSignAndApply() {
      const conditions = this.territorySelected &&
        Number(this.form.application.user_id) === Number(this.user.id) &&
        this.form.application.pass_kind !== PassKinds.PHD
      if (this.isSigning && !this.isScanCopy) {
        return !(this.user.isTerminalStaff && this.terminal.inn === this.form.organization.inn) && conditions
      }

      return !this.isSigning && this.isScanCopy && conditions
    },

    signModalId() {
      return 'modal-border'
    },

    terminalRegion() {
      return this.terminalRegions.find(region => region.id === this.form.application.terminal_region_id)
    },

    territorySelected() {
      return this.terminalRegion
    },

    terminalTariffTimeTypes() {
      let timeTypes = this.cfgOrganizationSubjectTimeType.filter(conf => conf.organization_subject_id === this.form.organization.subject_id)
      if (this.terminalRegion && this.terminalRegion?.pass_type !== 'all') {
        timeTypes = timeTypes.filter(conf => conf.time_type_id === this.terminalRegion.pass_type)
      }
      const terminalTariffTimeTypes = {}
      for (const timeType of timeTypes) {
        const time_type_id = timeType.time_type_id
        const constructor = Object.assign({}, timeType, timeType.timeType)
        terminalTariffTimeTypes[time_type_id] = new TimeTypeDto(constructor)
      }

      return terminalTariffTimeTypes
    }
  },

  async created() {
    loadCadesplugin()
    this.getSigners()

    this.checkPageAccess()
    this.debounceFetchConfigure = debounce(this.fetchConfiguredApplication, 300)
  },

  watch: {
    'form.application': {
      handler() {
        this.debounceFetchConfigure()
      },
      deep: true
    },

    'form.organization': {
      handler() {
        this.debounceFetchConfigure()
      },
      deep: true
    }
  },

  beforeMount() {
    this.showPreloader()
  },

  mounted() {
    this.loadPage()
  },

  updated() {
    this.checkPageAccess()
    this.$nextTick(function () {
      if (this.user && this.user.role && ['pnt', 'sb', 'sb_other', 'sb_truck', 'subdivision'].includes(this.user.role) && this.check) {
        this.getSigners()
      }
    })
  },

  methods: {
    fetchConfiguredApplication() {
      let vue = this
      return ApiClient.configureApplication({
        data: {
          application: {
            ...this.form.application
          },
          organization: {
            ...this.form.organization
          }
        }
      })
        .then(function (response) {
          if (response.status === 200 && response.data?.data) {
            vue.configuredApplication = new ConfiguredApplicationDto(response.data.data)
          }
        })
        .catch(function (response) {
          vue.configuredApplication = new ConfiguredApplicationDto({})
        })
    },

    async applyApplication(element) {
      Logger.log('Applying application')

      if (!this.checkAgreementBeforeCreate(element)) {
        return
      }
      await this.createApplication()
    },

    async applyDraftApplication(element) {
      Logger.log('Applying draft application...')

      if (!this.checkAgreementBeforeCreate(element)) {
        return
      }
      await this.createApplication(true)
    },

    async approvalCommand(application, statusCommandSettings) {
      const vue = this
      if (statusCommandSettings.alias) {
        ApiClient.updateStatus(application.id, {
          alias: statusCommandSettings.alias,
          comment: this.form.application.comment
        })
          .then(function (response) {
            if (response.status === 200) {
              if (history.length > 1) {
                history.back();
              } else {
                window.location.href = ApiClient.getApplicationScreenUrl();
              }
            } else {
              Logger.log(response)
              alert(response?.data?.message || 'Произошла ошибка')
              vue.$refs.modal.unsetPreload()
            }
          })
          .catch(function (error) {
            Logger.log(error)

            localStorage.setItem('application-form', JSON.stringify(this.form))
            vue.$refs.modal.unsetPreload()
          })
      } else {
        window.location.href = ApiClient.getApplicationScreenUrl()
      }
    },

    async approveApplication() {
      const approveAction = this.actions.find((action) => Boolean(action.for_approval) === true)

      if (approveAction) {
        await this.approvalCommand(this.form.application, approveAction)
      }
    },

    atLeastOneTransport(visitors) {
      for (const id in visitors) {
        if (visitors[id].transports.length === 0) {
          visitors[id].transports.push(
            new Transport(
              { type: Number(id) === 0 ? TransportTypes.Auto : visitors[0].transports[0].type }
            )
          )
        }
      }
    },

    canCheck(application) {
      if (this.isAgentOwner(application)) {
        return true
      }

      const service = ['subdivision', 'sb', 'sb_truck', 'sb_other'].includes(this.user.role)
      if (application.status === 'awaiting_signing' && !service) {
        return false
      }

      return application.status !== 'draft' && this.user && service
    },

    canPrint(application) {
      return Boolean(this.hasPermission(PermissionsEnum.printApplicationPrintedForm) && this.user && application.status !== 'draft')
    },

    changeDate() {
      if (this.form.visitors.length > 0) {
        for (let i = 0; i < this.form.visitors.length; i++) {
          if (this.form.visitors[i].personal.identification_number) {
            this.checkVisitorsInPass(i)
          }
        }
      }
    },

    checkActionClosedVisitors(action) {
      return parseInt(action.check_closed_users) === 0 ||
        (parseInt(action.check_closed_users) === 1 && this.approveForm.visitors.length !== this.form.visitors.length)
    },

    checkActionOwner(action) {
      return action.check_owner === 'all' ||
        (action.check_owner === 'own' && parseInt(this.form.application.user_id) === parseInt(this.user.id)) ||
        (action.check_owner === 'other' && parseInt(this.form.application.user_id) !== parseInt(this.user.id))
    },

    checkActionSubdivision(action) {
      return parseInt(action.check_subdivision) === 0 ||
        (parseInt(action.check_subdivision) === 1 && this.equalSubdivisions)
    },

    checkPageAccess() {
      if (!this.isView && !this.hasPermission(PermissionsEnum.createApplication)) {
        this.needLoadPage = false
        window.location.href = ApiClient.getApplicationScreenUrl()
      }
    },

    async createApplication(draft = false, successHandler = false, failureHandler = false) {
      if (!this.isDisabledSubmitButton) {
        if (this.form.application.vessel_access_id === VesselAccessesEnum.WITHOUT_VESSEL && Number(this.applicationGroupPurpose?.need_vessel) === 0) {
          this.form.vessels.length = 0
        }

        /**
         * @param {VisitorDocumentListItem} file
         */
        const formatFile = file => ({
          meta: {
            checked: file.meta.checked,
            date_of_expire: file.meta.date_of_expire?.isValid() ? file.meta.date_of_expire.format('YYYY-MM-DD') : null,
            number: file.meta.number ?? null,
            filename: file.meta.filename,
            uuid_any: file.meta.uuid_any
          }
        })
        const defaultHandler = function (result) {
          if (result.data && result.data.url) {
            window.location.href = result.data.url
          }
        }
        successHandler = successHandler || defaultHandler
        failureHandler = failureHandler || defaultHandler

        const applicationDocuments = {}
        const applicationDocTypes = this.calculatedApplicationDocuments.map(appDocument => appDocument.document.short_name)
        for (const applicationDocType of applicationDocTypes) {
          if (this.form?.application?.documents[applicationDocType]) {
            applicationDocuments[applicationDocType] = this.form?.application?.documents?.[applicationDocType]?.map(formatFile)
          }
        }

        const formData = {
          data: {
            application: {
              ...this.form.application,
              documents: applicationDocuments,
              number: null
            },
            organization: {
              ...this.form.organization
            },
            visitors: this.form.visitors.map(visitor => {
              const files = {}
              const visitorNationalityDocTypes = this.visitorNationalityDocuments(visitor).map(
                natDocument => natDocument.document.short_name
              )
              for (const docType of visitorNationalityDocTypes) {
                if (visitor.files[docType]) {
                  files[docType] = visitor.files[docType].map(formatFile)
                }
              }

              return {
                personal: visitor.personal,
                avatar: visitor.avatar,
                files,
                transports: (visitor.transports ?? []).map(function (transport) {
                  const files = {}
                  Object.keys(transport.files).forEach(function (doc) {
                    files[doc] = transport.files[doc]?.map(formatFile)
                  })

                  return {
                    ...transport,
                    files,
                    drivers: (transport.drivers ?? []).map(function (driver) {
                      const files = {}
                      Object.keys(driver.files).forEach(function (doc) {
                        files[doc] = driver.files[doc]?.map(formatFile)
                      })

                      return {
                        ...driver,
                        files
                      }
                    })
                  }
                })
              }
            }),
            email: this.form.email,
            phone: this.form.phone,
            vessels: this.form.vessels
          },
          draft
        }

        this.formSending = true
        await ApiClient.createApplication(formData)
          .then((response) => {
            localStorage.removeItem('application-form')

            if (response.status !== 200) {
              localStorage.setItem('application-form', JSON.stringify(this.form))

              return
            }

            const result = response.data

            if (result.status === ResponseStatuses.Success) {
              successHandler(result)
            } else {
              const errors = result.errors
              this.errors = errors

              if (errors.alert) {
                alert(errors.alert)
              }

              this.$nextTick().then(() => this.$scrollTo('.has-error', 500, { offset: -150 }))
            }
          })
          .catch(error => {
            Logger.log(error)

            localStorage.setItem('application-form', JSON.stringify(this.form))
          })
          .finally(() => {
            this.formSending = false
          })
      }
    },

    deleteApplication(application) {
      if (confirm('Удалить заявку? Она покинет нас навсегда')) {
        window.location.href = this.url('profile/delete?id=' + application.id)
      }
    },

    async editApplication() {
      this.formSending = true
      await ApiClient.editApplication({ data: this.form }).then((response) => {
        this.formSending = false
        if (response.data.status === 'success') {
          history.length > 1 ? history.back() : window.location.href = ApiClient.getApplicationScreenUrl()
        }
      })
    },

    fetchApplicationData() {
      return ApiClient.applicationData({
        application_id: this.$route.query.application_id,
        access_level: this.$route.query.access_level
      }).then((response) => {
        if (response.status === 403) {
          this.$router.push('/')

          return
        }

        const responseData = response.data
        const applicationData = responseData.data ?? {
          applicant: '',
          application: [],
          applicationPdfMenu: {},
          closedVisitors: {},
          organization: [],
          scanCopiesUrls: [],
          visitors: {}
        }

        applicationData.organization.subject_id = applicationData?.organization?.subject_id ?? OrganizationSubjects.Entity

        setOrganizationListeners = new Map([
          [NationalityIdChanged, new NationalityIdChanged()],
          [SubjectIdChanged, new SubjectIdChanged(applicationData?.organization?.subject_id)],
          [CheckOrganizationInn, new CheckOrganizationInn()]
        ])
        this.applicationPdfMenuHTML = applicationData.applicationPdfMenu
        this.setOrganization(applicationData.organization)
        setOrganizationListeners.set(CheckNeedAttorney, new CheckNeedAttorney())
        this.fillApplication(applicationData.application)
        this.fillVisitors(applicationData.visitors)
        this.fillScanCopies(applicationData.scanCopiesUrls)
        this.fillApplicant(applicationData.applicant)
        this.cleanUnnecessaryData()
        this.approveForm.visitors = applicationData.closedVisitors
      })
    },

    async fetchCfgMenuVisitor() {
      await ApiClient.cfgMenuData({
        id: this.form.application.id
      }).then((response) => {
        this.cfgMenuVisitor = response.data.data
      })
    },

    fetchApplicationDocuments() {
      const application_id = this.$route.query.application_id
      const application = this.form.application
      const visitorDocumentListPromise = ApiClient
        .getApplicationDocuments({ application_id })
        .then((response) => {
          const data = response.data.data
          const ret = {}
          ret[application_id] = data

          if (!data) {
            throw new Error(response.data.message || response.statusText)
          }

          return ret
        })

      return new VisitorDocumentListKeyItemPairHydrator()
        .setKeyItemPairs(
          new EagerPreviewVisitorDocumentListHydrator()
            .setKeyItemPairs(
              new VisitorDocumentListKeyItemPairHydrator()
                .setVisitorDocumentList(visitorDocumentListPromise)
                .hydrateKeyItemPairs()
            )
            .hydrate()
        )
        .hydrateVisitorDocumentList()
        .then(function (visitorDocumentList) {
          application.documents = Object.assign(application.documents, visitorDocumentList[application_id] ?? {})

          return application.documents
        })
    },

    async fetchDocuments() {
      if (this.isDuplicate || this.isView || this.isDraft) {
        await this.fetchApplicationDocuments()
      }
    },

    async fetchExtraApplicationData() {
      await ApiClient.extraApplicationData({
        application_id: this.$route.query.application_id,
        access_level: this.$route.query.access_level
      }).then((response) => {
        const responseData = response.data
        const extraApplicationData = responseData.data

        if (!extraApplicationData) {
          return
        }

        this.activityOrganizations = extraApplicationData.activityOrganizations
        this.agentOrganizations = extraApplicationData.agentOrganizations
        this.applicationDocuments = extraApplicationData.applicationDocuments
        this.applicationPurposes = extraApplicationData.applicationPurposes
        this.applicationStatus = extraApplicationData.applicationStatus
        this.applicationStatuses = extraApplicationData.applicationStatuses
        this.cfgOrganizationSubjectTimeType = extraApplicationData.cfgOrganizationSubjectTimeType
        this.nationalityDocuments = extraApplicationData.nationalityDocuments
        this.organizationSubjects = extraApplicationData.organizationSubjects
        this.passKinds = extraApplicationData.passKinds
        this.organizationSubjectsResidency = extraApplicationData.organizationSubjectsResidency
        this.passAccesses = extraApplicationData.passAccesses
          ?.map(value => new PassAccessDto(value)) ?? []
        this.personalIdentifications = extraApplicationData.personalIdentifications
        this.personalNationalities = extraApplicationData.personalNationalities
        this.purposeSubdivisions = extraApplicationData.purposeSubdivisions
        this.applicationCustomFields = extraApplicationData.applicationCustomFields
        this.statusActions = extraApplicationData.statusActions
        this.subjectPurpose = extraApplicationData.subjectPurpose
        this.terminal = extraApplicationData.terminal
        this.terminalOrganizations = extraApplicationData.terminalOrganizations
        this.terminalRegions = extraApplicationData.terminalRegions
        this.terminalRegionSectors = extraApplicationData.terminalRegionSectors
        this.terminalSubdivisions = extraApplicationData.terminalSubdivisions
        this.terminalTariffPeriods = extraApplicationData.terminalTariffPeriods
        this.transportColors = extraApplicationData.transportColors
        this.$store.commit('setTransportMarks', extraApplicationData.transportMarks)
        this.$store.commit('setTransportModels', extraApplicationData.transportModels)
        this.$store.commit('setDocumentValidators', extraApplicationData.documentValidators)
        this.$store.commit('setTransportStsTypes', extraApplicationData.transportStsTypes)
        this.transportDocuments = extraApplicationData.transportDocuments
        this.transportTypes = extraApplicationData.transportTypes
        this.vesselBerthBook = extraApplicationData.vesselBerthBook
        this.vesselAccesses = extraApplicationData.vesselAccesses
        this.visitorCategories = extraApplicationData.visitorCategories
        this.visitorCategoryPurposes = extraApplicationData.visitorCategoryPurposes
        this.paymentTypes = extraApplicationData.paymentTypes
        this.cfgFormFields = extraApplicationData.cfgFormFields
      })
    },

    async fetchNationalityMaskData() {
      await ApiClient.nationalityMaskData().then((response) => {
        this.documentMasks = response.data.data.documentMasks
      })
    },

    async fetchOtherData() {
      await ApiClient.otherData().then((response) => {
        const responseData = response.data
        const otherData = responseData.data

        if (!otherData) {
          return
        }

        this.textOffer = otherData.offer
        this.excelExample = otherData.excel_example
      })
    },

    async fetchVesselsData() {
      if ((this.isView || this.isDuplicate || this.isDraft) && this.form.application && this.form.application.vessel_access_id !== VesselAccessesEnum.WITHOUT_VESSEL) {
        await ApiClient.vesselsData({
          application_id: this.$route.query.application_id
        }).then((response) => {
          const vesselsData = response.data.data
          this.form.vessels = vesselsData.vessels
        })
      }
    },

    fillApplicant(applicant) {
      if (applicant === null) {
        return
      }

      this.form.applicant = applicant
    },

    fillApplication(application) {
      if (application === null) {
        return
      }

      this.form.application = {
        ...this.form.application,
        ...application
      }
    },

    /**
     * @param {OrganizationDto|null} organization
     * @returns {OrganizationDto}
     */
    fillOrganization(organization) {
      if (!organization) {
        return new OrganizationDto({})
      }

      // this.$set is used to introduce reactivity
      // as described in the https://v2.vuejs.org/v2/guide/reactivity.html#For-Arrays
      // since the method is also used by asynchronous functions and is subject to race condition.
      this.$set(this.form.organization, 'address', String(organization.address ?? ''))
      this.$set(this.form.organization, 'director_name', String(organization.director_name ?? ''))
      this.$set(this.form.organization, 'email', String(organization.email ?? ''))
      // this.$set(this.form.organization, 'fiz_address),String(organization.fiz_address ?? ''))
      this.$set(this.form.organization, 'inn', String(organization.inn ?? ''))
      this.$set(this.form.organization, 'innControlSumErr', Boolean(organization.innControlSumErr ?? false))
      this.$set(this.form.organization, 'innData', organization.innData ?? null)
      this.$set(this.form.organization, 'innError', Boolean(organization.innError ?? false))
      this.$set(this.form.organization, 'innHint', String(organization.innHint ?? ''))
      this.$set(this.form.organization, 'name', String(organization.name ?? ''))
      this.$set(this.form.organization, 'nationality_id', organization.nationality_id ?? 182)
      this.$set(this.form.organization, 'need_attorney', Boolean(organization.need_attorney ?? ''))
      this.$set(this.form.organization, 'ownerDirectorName', String(organization.ownerDirectorName ?? ''))
      this.$set(this.form.organization, 'ownerPositionOfManager', String(organization.ownerPositionOfManager ?? ''))
      this.$set(this.form.organization, 'phone', String(organization.phone ?? ''))
      this.$set(this.form.organization, 'position_of_manager', String(organization.position_of_manager ?? ''))
      this.$set(this.form.organization, 'subject_id', organization.subject_id ?? OrganizationSubjects.Entity)
      this.$set(this.form.organization, 'website', String(organization.website ?? ''))
      this.$forceUpdate()

      return organization
    },

    fillScanCopies(scanCopies) {
      if (!Array.isArray(scanCopies) || scanCopies.length === 0) {
        return
      }

      this.form.scanCopiesUrls = scanCopies
    },

    fillVisitors(visitors) {
      if (!Array.isArray(visitors) || visitors.length === 0) {
        return
      }
      if (this.form.application.pass_kind === PassKinds.TRANSPORT && this.isDuplicate) {
        visitors[0].transports.forEach(transport => {
          let drivers = transport.drivers
          let driversArr = Object.keys(drivers).map(key => drivers[key])
          let maxDriversCount = Number(this.configuration.form_drivers)
          transport.drivers = driversArr.slice(0, maxDriversCount)
        })
      }

      this.form.visitors = visitors.map(function (visitor) {
        visitor = new Visitor(cloneObject(visitor))
        const hydrateWithFiles = function (hasFilesField) {
          const files = hasFilesField.files.length === 0 ? {} : hasFilesField.files
          hasFilesField.files = {}

          if (Object.keys(files).length !== 0) {
            return new VisitorDocumentListKeyItemPairHydrator()
              .setKeyItemPairs(
                new VisitorDocumentListKeyItemPairHydrator()
                  .setVisitorDocumentList({ files })
                  .hydrateKeyItemPairs()
              )
              .hydrateVisitorDocumentList()
              .then(function (visitorDocumentList) {
                hasFilesField.files = visitorDocumentList.files
              })
          }
        }

        hydrateWithFiles(visitor)
        visitor.transports.forEach(hydrateWithFiles)

        return visitor
      })
      this.visitorsFormBlockKey = this.visitorsFormBlockKey === 0 ? 1 : 0
      this.handleTerminalRegion()
      this.checkVisitorOrganizationBlock()
    },

    fillTransports(visitors) {
      this.form.visitors[0].transports = visitors.reduce(function (accumulator, visitor) {
        visitor.transports.forEach(function (transport) {
          accumulator.push({ ...transport, user_position: visitor.personal.status })
        })

        return accumulator
      }, [])
    },

    cleanUnnecessaryData() {
      if (this.isDuplicate) {
        this.needAgentCheck ? this.form.application.subdivision_id = null : this.form.application.agent_organization_id = null
      }
    },

    getSigner(application, commandSettings) {
      let signer = new ClosedSigner({
        requestHashUrl: ApiClient.getSignerStepOneUrl(application),
        sendSignatureUrl: ApiClient.getSignerStepTwoUrl(application),
        certListBoxId: 'certListBox-' + application.id,
        statusSettings: commandSettings
      })

      this.$set(this.signers, application.id, signer)

      this.$bvModal.show(this.signModalId)
      const html = document.getElementsByTagName('html')[0]
      html.classList.add('html-modal-open')
    },

    getSigners() {
      const application = this.form.application
      if (application) {
        const signer = new ClosedSigner({
          requestHashUrl: ApiClient.getSignerStepOneUrl(application),
          sendSignatureUrl: ApiClient.getSignerStepTwoUrl(application),
          certListBoxId: this.certListBoxId
        })

        this.$set(this.signers, application.id, signer)
      }
    },

    handleDisableSubmitButton() {
      Logger.log('Submit button disabled!')

      this.disabledSubmitButton = true
    },

    handleEnableSubmitButton() {
      Logger.log('Submit button enabled!')

      this.disabledSubmitButton = false
    },

    handleTerminalRegion() {
      const action = TerminalRegionActions.actionsNames[this.terminalRegion?.transport_access]
      if (action) {
        const visitors = this.form.visitors
        this[action](visitors)
      }

      if (this.isPassKindPedestrian) {
        this.removeTransports(this.form.visitors)
      }
    },

    isAgentPrime() {
      return this.user.role === 'agent_prime'
    },

    isGuest() {
      return (this.user && this.user.role === null)
    },

    async loadPage() {
      if (!this.needLoadPage) {
        return
      }

      if (this.isNew) {
        const applicationForm = localStorage.getItem('application-form')

        if (applicationForm) {
          this.form = JSON.parse(applicationForm)
          this.restoredData = true
        }
      }

      if (!this.restoredData) {
        await this.fetchApplicationData()
      }

      await this.$store.dispatch('fetchErrorImages')
      await this.fetchExtraApplicationData()
      await this.fetchOtherData()
      await this.fetchNationalityMaskData()
      await this.fetchVesselsData()
      await this.fetchDocuments()
      this.prepareApplicationCustomFields()
      this.changeDate()
      this.hidePreloader()
      this.$nextTick(() => {
        this.pageScroll()
      })
    },

    onShowModal() {
      const signer = this.signers[Number(this.form.application.id)]

      if (window.cadesplugin) {
        window.cadesplugin.then(function () {
          signer.requestCertificates()
        })
      }
    },

    pageScroll() {
      if (location.hash) {
        this.$scrollTo(location.hash, 1000)
      }
    },
    prepareApplicationCustomFields() {
      if (this.form.application.custom_fields.length === 0) {
        this.form.application.custom_fields = {}
      }

      if (!this.isView) {
        let notVisibleFields = this.applicationCustomFields.filter((item) => Number(item.visible) === 0)
        notVisibleFields.forEach((item) => {
          delete this.form.application.custom_fields[item.id]
        })
      }
    },

    removeTransports(visitors) {
      for (const id in visitors) {
        visitors[id].transports = []
      }
    },

    setOrganization(value) {
      this.organizationDisabled = true
      const map = setOrganizationListeners.get(NationalityIdChanged).getNationalityIdToSubjectIdsMap()
      map.clear()
      for (const organizationSubjectResidency of this.organizationSubjectsResidency) {
        const nationalityId = Number(organizationSubjectResidency.nationality_id)
        const subjectIds = map.get(nationalityId) ?? []
        subjectIds.push(organizationSubjectResidency.subject_id)
        map.set(nationalityId, subjectIds)
      }

      let accumulator = new Promise(resolve => resolve(new OrganizationDto(value)))
      for (const setOrganizationListener of setOrganizationListeners.values()) {
        accumulator = accumulator.then(setOrganizationListener.trigger.bind(setOrganizationListener))
      }
      accumulator
        .then((organization) => {
          this.fillOrganization(organization)
          this.organizationDisabled = false
        })
    },

    setContractOrganization(organization) {
      this.form.application.contract_org_name = organization.short_name && organization.short_name !== ''
        ? organization.short_name
        : organization.name
      this.form.application.contract_org_inn = organization.inn
    },

    showActionButton(action) {
      return Boolean(
        this.checkActionOwner(action) &&
        this.checkActionSubdivision(action) &&
        this.checkActionClosedVisitors(action)
      )
    },

    async signAndApply(element) {
      Logger.log('Applying application before singing...')

      if (!this.checkAgreementBeforeCreate(element)) {
        return
      }

      const self = this
      const onSuccess = function (result) {
        if (self.isSigning && self.isScanCopy === false) {
          self.form.application = {
            ...self.form.application,
            ...result.data.application
          }
        }
        self.getSigners()
        self.$bvModal.show(self.signModalId)
        if (result.data && result.data.url) {
          self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
            if (modalId === self.signModalId) {
              window.location.href = result.data.url
            }
          })
        }
        if (result.data && result.data.actions) {
          self.statusActions = result.data.actions
        }
      }

      if (this.isSigning && this.isScanCopy === false) {
        await this.createApplication(false, onSuccess)
      } else {
        onSuccess({ data: { actions: this.actions } })
      }
    },

    async signAndApproval() {
      const signer = this.signers[this.form.application.id]
      let result = null
      const vue = this

      try {
        result = await signer.sign()
      } catch (err) {
        console.error(err)
        alert('При подписании произошла ошибка')
        vue.$refs.modal.unsetPreload()
      }

      if (result && (Object.keys(signer.statusSettings).length !== 0 || this.approveAction)) {
        await this.approvalCommand(
          this.form.application,
          Object.keys(signer.statusSettings).length !== 0
            ? signer.statusSettings
            : this.approveAction
        )
      } else {
        alert('Ошибка подписания')
        vue.$refs.modal.unsetPreload()
      }
    },

    spliceTransports(visitors) {
      for (const id in visitors) {
        if (visitors[id].transports.length > 1) {
          visitors[id].transports.splice(1, visitors[id].transports.length)
        }
      }
      this.atLeastOneTransport(visitors)
    },

    url(url) {
      return this.baseBackendUrl + '/' + url
    },

    visitorNationalityDocuments(visitor) {
      const nationality = visitor.personal?.nationality_id
      const nationalityDocuments = this.nationalityDocuments
      const docs = []

      for (let nationalityDocument of nationalityDocuments) {
        if ((nationalityDocument.nationality_id === null || Number(nationalityDocument.nationality_id) === Number(nationality)) &&
          (visitor.personal.identification_id === nationalityDocument.nationality_identification_id)) {
          if (nationalityDocument.application_group_purpose_id &&
            nationalityDocument.application_group_purpose_id !== this.form.application.application_group_purpose_id) {
            continue
          }

          if (nationalityDocument.region_id &&
            nationalityDocument.region_id !== this.form.application.terminal_region_id) {
            continue
          }

          docs.push(nationalityDocument)
        }
      }

      return docs
    },

    clearErrorMessage() {
      if (this.agreementErrorMessage === true) {
        this.agreementErrorMessage = false
      }
    },

    checkAgreementBeforeCreate(element) {
      if (this.agreement === false) {
        this.agreementErrorMessage = true
        this.$scrollTo('.has-error', 500, { offset: -150 })
        element.target.blur()

        return false
      }
      return true
    }
  },

  beforeRouteUpdate(to, from, next) {
    next()

    this.showPreloader()
    this.form = cloneObject(this.defaultForm)
    this.approveForm = cloneObject(this.defaultApproveForm)
    this.loadPage()
  }
}
</script>
